<template>
	<div class="nano m-b-3 widget-form" v-if="showForm">

		<div class="form-group" :class="{'m-b-0': mock}">
			<label for="mockDataCheckbox" class="c-input c-toggle align-middle">
				<input id="mockDataCheckbox" type="checkbox" role="switch" v-model="mock" @change="reload(true)">
				<span class="c-indicator"></span>
				<span class="mock-label">Use mock data</span>
			</label>

			<button class="btn btn-xs btn-primary" @click="reload(false)"><span class="ico-autoship icon-adjust-vert"></span><span class="btn-icon-text">Refresh</span></button>
			<button class="btn btn-xs btn-secondary-outline btn-show-hide-panel" @click="hidePanel()"><span class="ico-arrow-right-sm"></span></button>
		</div>

		<div class="form-group" v-show="!mock">
			<label for="selectLocation">Location</label>
			<select id="selectLocation" class="c-select c-select-sm" v-model="club">
				<option value="Ardmore">Ardmore</option>
				<option value="Chanhassen">Chanhassen</option>
				<option value="Crosstown (Eden Prairie)">Crosstown (Eden Prairie)</option>
				<option value="Des Moines">Des Moines</option>
				<option value="Lenexa">Lenexa</option>
				<option value="Target Center (Minneapolis)">Target Center (Minneapolis)</option>
			</select>
		</div>

		<div class="form-group" v-show="!mock">
			<label for="selectExperience">Experience</label>
			<select id="selectExperience" class="c-select c-select-sm" v-model="experience">
				<option value="member">Member</option>
				<option value="prospect">Prospect</option>
			</select>
		</div>

		<div class="form-group m-t-1" v-show="!mock">
			<label for="textProfile">
				<span class="align-bottom m-r-xs">Profile Store: {{ profileLoaderMessage }}</span>
				<a class="btn btn-xs btn-primary" @click="showProfileLoader()"><span class="ico-clipboard icon-adjust-vert"></span></a>
				<a v-show="profileStore" class="btn btn-xs btn-primary" @click="clearProfileData()">CLEAR</a>
				<textarea v-show="profileLoaderVisible" id="textProfile" class="form-control" style="height:30px;resize:none;margin-top:3px;" placeholder="Paste ProfileStore JSON here..." v-model="profileString"></textarea>
			</label>
		</div>

		<div class="form-group" v-show="!mock && profileStore">
			<label for="sendSso" class="c-input c-checkbox-sm">
				<input type="checkbox" v-model="sendSso" id="sendSso">
				<span class="c-indicator"></span>
				Send SSO: <span class="profile-display">{{ sso }}</span>
				<!-- <input id="textSso" class="form-control" type="text" maxlength="38" v-model="sso">
				<a class="btn btn-xs btn-primary" @click="showInfoModal('sso')"><span class="ico-info"></span></a> -->
			</label>
		</div>

		<div class="form-group" v-show="!mock && profileStore">
			<label for="sendJwe" class="c-input c-checkbox-sm">
				<input type="checkbox" v-model="sendJwe" id="sendJwe">
				<span class="c-indicator"></span>
				Send JWE: <span class="profile-display">{{ jwe }}</span>
				<!-- <input id="textSso" class="form-control" type="text" maxlength="38" v-model="sso">
				<a class="btn btn-xs btn-primary" @click="showInfoModal('sso')"><span class="ico-info"></span></a> -->
			</label>
		</div>

		<div class="form-group" v-show="!mock && profileStore">
			<label for="sendProfile" class="c-input c-checkbox-sm">
				<input type="checkbox" v-model="sendProfile" id="sendProfile">
				<span class="c-indicator"></span>
				Send Remember: <span class="profile-display">{{ profile }}</span>
				<!-- <input id="textProfile" class="form-control" type="text" maxlength="38" v-model="profile">
				<a class="btn btn-xs btn-primary" @click="showInfoModal('profile')"><span class="ico-info"></span></a> -->
			</label>
		</div>

		<div class="form-group m-t-1 m-b-0" v-show="!mock">
			<span class="d-inline-block align-middle m-l-sm">Classes&nbsp;</span>
			<label for="searchFormatEvent" class="c-input c-toggle align-middle">
				<input id="searchFormatEvent" type="checkbox" role="switch" v-model="searchFormatEvent">
				<span class="c-indicator"></span>
			</label>
			<span class="d-inline-block align-middle m-l-sm">Events</span>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import { StateService } from '@/services/state.service';

export default defineComponent({
	name: 'RealDataSub',
	props: {
		showForm: {
			default: false,
			type: Boolean
		}
	},
	data() {
		return {
			sso: '',
			profile: '',
			jwe: '',
			mock: true,
			sendSso: true,
			sendProfile: true,
			sendJwe: true,
			club: 'Chanhassen',
			searchFormatEvent: false,
			panelVisible: true,
			profileLoaderVisible: false,
			profileString: null,
			profileStore: null,
			profileLoaderMessage: '',
			members: [],
			experience: 'member'
		};
	},
	watch: {
		// sso: function() {
		// 	this.saveDevSettings();
		// },
		// profile: function() {
		// 	this.saveDevSettings();
		// },
		sendSso: function() {
			this.saveDevSettings();
		},
		sendProfile: function() {
			this.saveDevSettings();
		},
		sendJwe: function() {
			this.saveDevSettings();
		},
		club: function() {
			this.saveDevSettings();
		},
		experience: function() {
			this.saveDevSettings();
		},
		searchFormatEvent: function() {
			this.saveDevSettings();
		},
		mock: function() {
			this.saveDevSettings();
			this.$emit('mockChanged', this.mock);
		},
		profileString: function() {
			if (this.profileString) {
				try {
					this.profileStore = JSON.parse(this.profileString);
				} catch {
					this.profileStore = null;
				}

				if (this.profileStore) {
					this.sso = this.profileStore.sso;
					this.profile = this.profileStore.token;
					this.jwe = this.profileStore.jwe; // TODO: This value doesn't exist on profileStore (only jwt), so anything that depends on sending JWE (such as returning spa reservations) won't work
					if (this.sso) this.sendSso = true;
					if (this.profile) this.sendProfile = true;
					if (this.jwe) {
						this.sendSso = false;
						this.sendJwe = true;
					}
					this.saveDevSettings();
					this.profileLoaderMessage = 'LOADED';
				} else {
					this.profileLoaderMessage = 'ERROR';
				}
				this.profileString = null;
				this.profileLoaderVisible = false;
			}
		}
	},
	mounted() {
		this.loadDevSettings();
		this.$emit('mockChanged', this.mock);
	},
	methods: {
		getClubId() {
			switch (this.club) {
				case 'Ardmore': return 262;
				case 'Chanhassen': return 151;
				case 'Crosstown (Eden Prairie)': return 173;
				case 'Des Moines': return 238;
				case 'Lenexa': return 198;
				case 'Target Center (Minneapolis)': return 172;
				default: return 151;
			}
		},
		saveDevSettings() {
			StateService.setDevSettings({
				sso: this.sso,
				profile: this.profile,
				jwe: this.jwe,
				mock: this.mock,
				sendSso: this.sendSso,
				sendProfile: this.sendProfile,
				sendJwe: this.sendJwe,
				club: this.club || 'Chanhassen',
				clubId: this.getClubId(),
				searchFormatEvent: this.searchFormatEvent,
				profileStore: this.profileStore,
				panelVisible: this.panelVisible,
				experience: this.experience || 'member'
			});
		},
		loadDevSettings() {
			const settings = StateService.getDevSettings() || {
				sso: '',
				jwe: '',
				mock: true
			};
			this.sso = settings.sso;
			this.jwe = settings.jwe;
			this.mock = settings.mock;
			this.profile = settings.profile;
			this.sendSso = settings.sendSso;
			this.sendJwe = settings.sendJwe;
			this.sendProfile = settings.sendProfile;
			this.club = settings.club;
			this.clubId = this.getClubId();
			this.searchFormatEvent = settings.searchFormatEvent;
			this.panelVisible = settings.panelVisible;
			this.profileStore = settings.profileStore || null;
			this.experience = settings.experience || 'member';

			if (this.profileStore) {
				this.profileLoaderMessage = 'LOADED';
			}
		},
		reload(toggled) {
			if (toggled) {
				window.location.href = '/index.html?mock-data-toggled=1';
				return;
			}
			window.location.reload();
		},
		showInfoModal(type) {
			if (type === 'sso') {
				this.$emit('infoShow', {
					title: 'SSOID',
					description: 'Bookmarklet to quickly retrieve your SSOID',
					bookmarklet: 'javascript: (function(){var data=window.ef.profileStore.getInitialData();window.prompt(\'SSOID\',data.sso);})();'
				});
			}
			if (type === 'profile') {
				this.$emit('infoShow', {
					title: 'Profile Token',
					description: 'Bookmarklet to quickly retrieve your Profile Token',
					bookmarklet: 'javascript: (function(){var data=window.ef.profileStore.getInitialData();window.prompt(\'Profile Token\',data.profile);})();'
				});
			}
		},
		hidePanel() {
			this.panelVisible = false;
			this.saveDevSettings();
			this.$emit('panelChanged', this.panelVisible);
		},
		setPanel(visible) {
			this.panelVisible = visible;
			this.saveDevSettings();
		},
		showProfileLoader() {
			this.profileLoaderVisible = !this.profileLoaderVisible;
			this.profileLoaderMessage = this.profileStore ? 'LOADED' : '';
		},
		clearProfileData() {
			this.profileStore = null;
			this.sso = null;
			this.profile = null;
			this.jwe = null;
			this.sendSso = false;
			this.sendProfile = false;
			this.sendJwe = false;
			this.saveDevSettings();
			this.profileLoaderMessage = '';
		}
	}
});
</script>

<style lang="scss" scoped>
.widget-form {
	font-size: 11px;
	min-width: 21.25rem;
	input[type=text],
	textarea,
	select {
		width: 17rem;
		font-size: 11px;
		margin-bottom: 3px;
	}
	.form-group input.form-control {
		display: inline-block;
	}
	.mock-label {
		margin: 0 5px 0 5px;
	}
	.profile-display {
		font-size: 9px;
		display: block;
		overflow: auto;
		width: 15.5rem;
		padding: 2px 8px;
		white-space: nowrap;
		border: 1px solid $gray-9;
		border-radius: 10px;
		box-shadow: inset 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
	}
}

</style>
